import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { useImage } from '@/shared/composables/image'
import useValidationRules from '@/shared/composables/validation'
import { userApi } from '@/enitites/user'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReleaseProfile',
  setup(__props) {

const { getImageById } = useImage()
const rules = useValidationRules()
const route = useRoute()
const router = useRouter()

const password = ref('')
const passwordRef = ref<HTMLInputElement | null>(null)
const confirmedPassword = ref('')
const confirmPasswordRef = ref<HTMLInputElement | null>(null)
const email = ref('')
const showPassword = ref(false)
const error = ref<string | null>(null)
const valid = ref(true)
const fullName = ref('')
const avatar = ref('')

const getReleasingProfileId = computed(() => Number(route.params.id))

const saveProfileData = async (id: number) => {
  const user = await userApi.getUser(id)
  if (!user) {
    await store.dispatch('setIsNotFound', !user)
    return
  }

  localStorage.setItem('currentProfileId', id.toString())
  await store.dispatch('setUserDB', user)
  await router.push({ name: 'ProfileSetting', query: { tabName: 'SettingsOtherProfiles' } })
}

const sendProfileData = async () => {
  const { data } = await userApi.releaseProfile({
    id: getReleasingProfileId.value,
    password: password.value,
    email: email.value,
  })

  if (!data) return

  await saveProfileData(data.id)
}

const validateEqual = () => {
  error.value = password.value === confirmedPassword.value ? null : 'Passwords must be equal'
  if (error.value) return
  sendProfileData()
}

const fetchReleasingProfile = async () => {
  const user = await userApi.getUser(getReleasingProfileId.value)
  if (!user) {
    await store.dispatch('setIsNotFound', !user)
    return
  }

  fullName.value = user.fullName
  avatar.value = user.avatar
}

onMounted(() => {
  fetchReleasingProfile()
})

return { __sfc: true,getImageById, rules, route, router, password, passwordRef, confirmedPassword, confirmPasswordRef, email, showPassword, error, valid, fullName, avatar, getReleasingProfileId, saveProfileData, sendProfileData, validateEqual, fetchReleasingProfile }
}

})